!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.LinkedInTag = t() : e.LinkedInTag = t();
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        n.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e, t, n) {
    "use strict";

    (function (e) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
          r = "undefined" != typeof window && void 0 !== window.document,
          i = "object" === ("undefined" == typeof self ? "undefined" : n(self)) && self.constructor && "DedicatedWorkerGlobalScope" === self.constructor.name,
          o = void 0 !== e && null != e.versions && null != e.versions.node;
      t.isBrowser = r, t.isWebWorker = i, t.isNode = o;
    }).call(this, n(3));
  }, function (e, t, n) {
    e.exports = n(2);
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0);

    function i(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    var a = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.initialized = !1, this.disabled = !1, this.partnerId = "";
      }

      var t, n, a;
      return t = e, (n = [{
        key: "warn",
        value: function value() {
          for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
            n[r] = arguments[r];
          }

          (e = console).info.apply(e, i(["[react-linkedin-insight]"].concat(n)));
        }
      }, {
        key: "verifyInit",
        value: function value() {
          return this.initialized || this.warn("LinkedIn Insight Tag not initialized. Before using, call LinkedInTag.init with required params"), this.initialized;
        }
      }, {
        key: "init",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : !r.isBrowser;

          if (this.disabled = t, this.partnerId = String(e), !t) {
            if (!this.partnerId) return this.warn("Partner id is empty.");
            window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [], window._linkedin_data_partner_ids.push(e);
            var n = document.getElementsByTagName("script")[0],
                i = document.createElement("script");
            i.type = "text/javascript", i.async = !0, i.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js", n.parentNode.insertBefore(i, n), this.initialized = !0;
          }
        }
      }, {
        key: "track",
        value: function value(e) {
          if (this.verifyInit() && !this.disabled) {
            if (!this.partnerId || !window._linkedin_data_partner_ids[0]) return this.warn("Partner id is empty.");
            this.warn("partnerId", this.partnerId, "_linkedin_data_partner_ids", window._linkedin_data_partner_ids[0]), this.partnerId = this.partnerId || window._linkedin_data_partner_ids[0];
            var t = "https://dc.ads.linkedin.com/collect/?pid=".concat(this.partnerId, "&conversionId=").concat(e, "&fmt=gif"),
                n = document.createElement("img");
            n.alt = "", n.height = 1, n.width = 1, n.src = t;
          }
        }
      }]) && o(t.prototype, n), a && o(t, a), e;
    }();

    t.default = new a();
  }, function (e, t) {
    var n,
        r,
        i = e.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function u(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (e) {
        n = o;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (e) {
        r = a;
      }
    }();
    var c,
        s = [],
        l = !1,
        f = -1;

    function d() {
      l && c && (l = !1, c.length ? s = c.concat(s) : f = -1, s.length && p());
    }

    function p() {
      if (!l) {
        var e = u(d);
        l = !0;

        for (var t = s.length; t;) {
          for (c = s, s = []; ++f < t;) {
            c && c[f].run();
          }

          f = -1, t = s.length;
        }

        c = null, l = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

          try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }

    function y(e, t) {
      this.fun = e, this.array = t;
    }

    function h() {}

    i.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      s.push(new y(e, t)), 1 !== s.length || l || u(p);
    }, y.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = h, i.addListener = h, i.once = h, i.off = h, i.removeListener = h, i.removeAllListeners = h, i.emit = h, i.prependListener = h, i.prependOnceListener = h, i.listeners = function (e) {
      return [];
    }, i.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }]);
});